import { createIcon } from '@chakra-ui/icon';
import React from 'react';

/**
 * 紙飛行機の送信アイコン (Material Icons の send)。
 * テンプレートが再送信ボタンに置いている `send` の代替
 * (SCR001 No.14 / SCR002 No.59・No.65)。
 * ReloadIcon (循環矢印) は再読み込み用なので取り違えないこと。
 */
export const SendIcon = createIcon({
  path: <path fill="currentColor" d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />,
  viewBox: '0 0 24 24',
});
